import { httpService } from 'core-utilities';

const notificationSettingsAuthority = (() => {
  let isInitialized = false;
  const successStatue = 'Success';

  let canToggleMobilePushNotificationSettings = false;
  let notificationsDomain = '';
  const loadSettings = () => {
    const settings = document.getElementById('notification-settings');
    canToggleMobilePushNotificationSettings = settings.getAttribute(
      'data-can-toggle-mobile-push-notifications'
    );
    notificationsDomain = settings.getAttribute('data-notifications-domain');
  };

  const initialize = () => {
    loadSettings();
    isInitialized = true;
  };

  const canToggleMobilePushNotifications = () => {
    return canToggleMobilePushNotificationSettings;
  };

  const deregisterCurrentDevice = (onSuccess, onFailure) => {
    const urlConfig = {
      url: `${notificationsDomain}/v2/push-notifications/deregister-current-device`,
      withCredentials: true
    };
    httpService.post(urlConfig).then(
      successResponse => {
        const { data: msg } = successResponse;
        if (msg?.statusMessage === successStatue) {
          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(true);
          }
        }
      },
      e => {
        if (onFailure && typeof onFailure === 'function') {
          onFailure(e);
        }
      }
    );
  };

  const isPushEnabled = callback => {
    const urlConfig = {
      url: `${notificationsDomain}/v2/push-notifications/get-current-device-destination`,
      withCredentials: true
    };
    httpService.get(urlConfig).then(
      successResponse => {
        const { data: response } = successResponse;
        if (response?.destination) {
          callback(true);
        } else {
          callback(false);
        }
      },
      failureResponse => {
        console.log(failureResponse);
      }
    );
  };
  initialize();
  return {
    initialize,
    isPushEnabled,
    canToggleMobilePushNotifications,
    deregisterCurrentDevice
  };
})();

export default notificationSettingsAuthority;
